import React from 'react';
import { Box, Collapse, styled, TableCell, TableRow } from '@mui/material';

const ExpansionCell = styled(TableCell, {
    shouldForwardProp: (prop) => prop !== '$isLast'
})<{ $isLast?: boolean }>(({ theme, $isLast }) => ({
    padding: 0,
    borderBottom: 'none',
    borderTop: 'none',
    borderLeft: `1px solid ${theme.palette.semantic.bd.default}`,
    backgroundColor: theme.palette?.semantic?.bg?.subtle,
    boxShadow: 'inset 0px 6px 8px -4px rgba(0, 0, 0, 0.12)',
    ...($isLast && {
        borderBottom: `1px solid ${theme.palette.semantic.bd.default}`,
        borderRight: `1px solid ${theme.palette.semantic.bd.default}`,
        borderBottomLeftRadius: '8px',
        borderBottomRightRadius: '8px'
    })
}));

const ExpansionInner = styled(Box)(() => ({
    padding: 32,
    '& .MuiTableHead-root .MuiTableCell-root': {}
}));

interface EditableTableExpansionProps {
    open: boolean;
    colSpan: number;
    children: React.ReactNode;
    isLast?: boolean;
}

export const EditableTableExpansion: React.FC<EditableTableExpansionProps> = ({
    open,
    colSpan,
    children,
    isLast = false
}) => {
    return (
        <TableRow>
            <ExpansionCell colSpan={colSpan} $isLast={isLast}>
                <Collapse in={open} unmountOnExit>
                    <ExpansionInner>{children}</ExpansionInner>
                </Collapse>
            </ExpansionCell>
        </TableRow>
    );
};
